import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogBoxService {

  constructor() { }

  public autoFillData = new BehaviorSubject(false);
}
